import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

const StyledButton = styled.button`
  width: 100%;
  height: 100%;
  border: ${rem(1)} solid #eaeaea;
  color: #eaeaea;
  background: #fff;
  border-radius: ${rem(4)};
  transition: opacity 0.2s ease;
  opacity: ${(props: any) => (props.disabled ? 0.5 : 1)};

  &:hover {
    cursor: ${(props: any) => (props.disabled ? 'not-allowed' : 'pointer')};
    opacity: ${(props: any) => (props.disabled ? 0.5 : 0.8)};
  }

  &:active {
    opacity: 0.6;
  }

  &:focus {
    outline: none;
  }
`;

export interface NewButtonProps {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export class NewButton extends React.Component<NewButtonProps> {
  public static defaultProps = {
    disabled: false,
  };

  public render() {
    const { className, onClick, children, disabled } = this.props;
    return (
      <StyledButton
        onClick={onClick}
        className={className ? className : ''}
        disabled={disabled}
      >
        {children}
      </StyledButton>
    );
  }
}
